
import {NgModule} from '@angular/core';
import {IfaCampaignComponent} from './ifa-campaign.component';
import {WeHaveBeenInTheNewsModule} from '../../common/we-have-been-in-the-news/we-have-been-in-the-news.module';
import {CoreTeamSectionModule} from '../../common/core-team-section/core-team-section.module';
import {AwardsAndAccreditationsModule} from '../../common/awards-and-accreditations/awards-and-accreditations.module';
import {CampaignEnquireFooterModule} from '../../common/campign-enquire-footer/campaign-enquire.module';
import {LogoOnlyHeaderModule} from '../../headers/logo-only-header/logo-only-header.module';
import {EnquireNowFormModule} from '../../views/enquire-now-form/enquire-now-form.module';
import {MatButtonModule} from '@angular/material';
import {PartnerWithUsForBenefitsModule} from '../../common/partner-with-us-for-benefits/partner-with-us-for-benefits.module';

@NgModule({
    declarations: [IfaCampaignComponent],
    imports: [CoreTeamSectionModule, WeHaveBeenInTheNewsModule, AwardsAndAccreditationsModule, CampaignEnquireFooterModule, LogoOnlyHeaderModule, EnquireNowFormModule, MatButtonModule, PartnerWithUsForBenefitsModule]
})
export class IfaCampaignModule {
}
